import React, { useEffect, useState } from 'react';
import { canPreviewName, previewFile, gridToHtml } from '../utils/filePreview';

/**
 * The "did I attach the right file?" grid under a staged spreadsheet/text
 * file — first rows × left columns, read from a small head slice. Renders
 * nothing for PDFs/images or when the file can't be read: a picker must
 * never break because a preview did.
 */
export default function StagedFilePreview({ file }) {
  const [html, setHtml] = useState('');
  useEffect(() => {
    let live = true;
    setHtml('');
    if (!file || !canPreviewName(file.name)) return undefined;
    previewFile(file).then((grid) => {
      if (live && grid) setHtml(gridToHtml(grid));
    });
    return () => { live = false; };
  }, [file]);
  if (!html) return null;
  // gridToHtml escapes cell text; the markup is one shared source with the
  // plain-script pages.
  return <div className="file-preview-slot" dangerouslySetInnerHTML={{ __html: html }} />;
}
